module.exports = __webpack_public_path__ + "media/images/lp/industries/mv-results_sp-b953c052082667f9fa5098d6ef9bc89e.svg";